import { defineMessages } from '../../i18n/index.ts'

export const plansMessages = defineMessages({
	en: {
		suggested: 'Suggested for this source',
		startGo: 'Make lesson plan',
		hubTitle: 'Lesson plan',
		hubShort: 'Lesson plan',
		hubBlurb:
			'Turn a source into a lesson: warm-up, reading or watching with pause points, your quiz, discussion, homework. Minutes always add up.',
		pickTitle: 'Plan a lesson from a source',
		pickLead: 'Start with what you are teaching from. You choose the length next.',
		link: 'Lesson plan',
		opening: 'Opening',
		openFailed: 'Could not open this',
		back: 'Back to the source',
		backToSource: 'Back to the source',
		createTitle: (title: string) => `Lesson plan for ${title}`,
		createLead: 'The plan uses this source and any exercises you already made from it.',
		outline: 'Lesson at a glance',
		length: 'Lesson length',
		minutesOption: (n: number) => `${n} min`,
		notes: 'Anything the plan should include? (optional)',
		notesHint: 'For example: a group task, a focus on new words, or a revision lesson',
		make: 'Draft the plan',
		making: 'Drafting the plan... about a minute',
		failed: 'The plan did not come back',
		noText: 'This source has no text yet. Add the text first.',
		existing: 'Plans for this source',
		titleLabel: 'Plan title',
		total: (n: number) => `Total: ${n} min`,
		minutesLabel: 'Minutes',
		stepTitle: 'Step',
		detailLabel: 'What to do',
		addStep: 'Add a step',
		removeStep: 'Remove',
		openQuiz: (title: string) => `Quiz: ${title}`,
		save: 'Save changes',
		saving: 'Saving...',
		saved: 'Saved',
		unsaved: 'Unsaved changes',
		saveFailed: 'Could not save the plan',
		del: 'Delete plan',
		delConfirm: 'Delete for good',
		delCancel: 'Keep it',
		min: 'min',
		lengthNote: 'Changing the length keeps the order and rescales the minutes.',
		tryAgain: 'Try again',
		print: 'Print',
		again: 'Draft again',
		againTitle: 'Draft this plan again',
		againBody: 'Same source and length. This plan stays in your list and the new one opens next.',
		againHint:
			'Say what to change, for example: a shorter warm-up, more speaking, or a revision lesson',
		againUnsaved: 'Edits you have not saved will not carry over.',
	},
	ro: {
		suggested: 'Sugerat pentru această sursă',
		startGo: 'Fă planul lecției',
		hubTitle: 'Plan de lecție',
		hubShort: 'Plan de lecție',
		hubBlurb:
			'Transformă o sursă într-o lecție: încălzire, citire sau vizionare cu pauze, testul tău, discuție, temă. Minutele se adună mereu.',
		pickTitle: 'Planifică o lecție dintr-o sursă',
		pickLead: 'Începe cu materialul de la care predai. Alegi durata după aceea.',
		link: 'Plan de lecție',
		opening: 'Se deschide',
		openFailed: 'Nu am putut deschide',
		back: 'Înapoi la sursă',
		backToSource: 'Înapoi la sursă',
		createTitle: (title: string) => `Plan de lecție pentru ${title}`,
		createLead: 'Planul folosește această sursă și exercițiile pe care le-ai creat deja din ea.',
		outline: 'Lecția pe scurt',
		length: 'Durata lecției',
		minutesOption: (n: number) => `${n} min`,
		notes: 'Ceva ce ar trebui să includă planul? (opțional)',
		notesHint: 'De exemplu: o sarcină în grup, accent pe cuvinte noi sau o lecție de recapitulare',
		make: 'Creează planul',
		making: 'Se creează planul... durează cam un minut',
		failed: 'Planul nu a venit',
		noText: 'Această sursă nu are încă text. Adaugă mai întâi textul.',
		existing: 'Planuri pentru această sursă',
		titleLabel: 'Titlul planului',
		total: (n: number) => `Total: ${n} min`,
		minutesLabel: 'Minute',
		stepTitle: 'Pas',
		detailLabel: 'Ce se face',
		addStep: 'Adaugă un pas',
		removeStep: 'Șterge',
		openQuiz: (title: string) => `Test: ${title}`,
		save: 'Salvează modificările',
		saving: 'Se salvează...',
		saved: 'Salvat',
		unsaved: 'Modificări nesalvate',
		saveFailed: 'Nu am putut salva planul',
		del: 'Șterge planul',
		delConfirm: 'Șterge definitiv',
		delCancel: 'Păstrează-l',
		min: 'min',
		lengthNote: 'Schimbarea duratei păstrează ordinea și reface minutele proporțional.',
		tryAgain: 'Încearcă din nou',
		print: 'Tipărește',
		again: 'Creează din nou',
		againTitle: 'Creează planul din nou',
		againBody:
			'Aceeași sursă și aceeași durată. Planul acesta rămâne în listă, iar cel nou se deschide după aceea.',
		againHint:
			'Spune ce să se schimbe, de exemplu: o încălzire mai scurtă, mai multă exprimare orală sau o lecție de recapitulare',
		againUnsaved: 'Modificările nesalvate nu se păstrează.',
	},
	ru: {
		suggested: 'Рекомендуем для этого источника',
		startGo: 'Составить план урока',
		hubTitle: 'План урока',
		hubShort: 'План урока',
		hubBlurb:
			'Превратите материал в урок: разминка, чтение или просмотр с паузами, ваш тест, обсуждение, домашнее задание. Минуты всегда сходятся.',
		pickTitle: 'План урока по материалу',
		pickLead: 'Начните с материала, по которому учите. Длительность выберете дальше.',
		link: 'План урока',
		opening: 'Открываем',
		openFailed: 'Не удалось открыть',
		back: 'Назад к источнику',
		backToSource: 'Назад к источнику',
		createTitle: (title: string) => `План урока: ${title}`,
		createLead: 'План использует этот материал и упражнения, которые вы уже по нему сделали.',
		outline: 'Урок по шагам',
		length: 'Длительность урока',
		minutesOption: (n: number) => `${n} мин`,
		notes: 'Что ещё включить в план? (необязательно)',
		notesHint: 'Например: групповое задание, упор на новые слова или урок повторения',
		make: 'Составить план',
		making: 'Составляем план... около минуты',
		failed: 'План не пришёл',
		noText: 'В этом источнике пока нет текста. Сначала добавьте текст.',
		existing: 'Планы по этому источнику',
		titleLabel: 'Название плана',
		total: (n: number) => `Всего: ${n} мин`,
		minutesLabel: 'Минуты',
		stepTitle: 'Этап',
		detailLabel: 'Что делать',
		addStep: 'Добавить этап',
		removeStep: 'Удалить',
		openQuiz: (title: string) => `Тест: ${title}`,
		save: 'Сохранить изменения',
		saving: 'Сохраняем...',
		saved: 'Сохранено',
		unsaved: 'Есть несохранённые изменения',
		saveFailed: 'Не удалось сохранить план',
		del: 'Удалить план',
		delConfirm: 'Удалить навсегда',
		delCancel: 'Оставить',
		min: 'мин',
		lengthNote:
			'При смене длительности порядок сохраняется, минуты пересчитываются пропорционально.',
		tryAgain: 'Попробовать снова',
		print: 'Печать',
		again: 'Составить заново',
		againTitle: 'Составить план заново',
		againBody:
			'Тот же источник и та же длительность. Этот план останется в списке, а новый откроется следом.',
		againHint:
			'Напишите, что изменить, например: более короткая разминка, больше устной речи или урок повторения',
		againUnsaved: 'Несохранённые правки не перенесутся.',
	},
	fr: {
		suggested: 'Suggéré pour cette source',
		startGo: 'Créer le plan de cours',
		hubTitle: 'Plan de cours',
		hubShort: 'Plan de cours',
		hubBlurb:
			'Transformez une source en cours : échauffement, lecture ou visionnage avec pauses, votre quiz, discussion, devoirs. Les minutes tombent toujours juste.',
		pickTitle: 'Préparer un cours à partir d’une source',
		pickLead: 'Commencez par ce que vous enseignez. Vous choisirez la durée ensuite.',
		link: 'Plan de cours',
		opening: 'Ouverture',
		openFailed: 'Impossible d’ouvrir',
		back: 'Retour à la source',
		backToSource: 'Retour à la source',
		createTitle: (title: string) => `Plan de cours : ${title}`,
		createLead:
			'Le plan s’appuie sur cette source et sur les exercices que vous en avez déjà tirés.',
		outline: 'Le cours en bref',
		length: 'Durée du cours',
		minutesOption: (n: number) => `${n} min`,
		notes: 'Quelque chose à inclure dans le plan ? (facultatif)',
		notesHint:
			'Par exemple : un travail de groupe, un accent sur le vocabulaire nouveau ou une leçon de révision',
		make: 'Rédiger le plan',
		making: 'Rédaction du plan... environ une minute',
		failed: 'Le plan n’est pas arrivé',
		noText: 'Cette source n’a pas encore de texte. Ajoutez d’abord le texte.',
		existing: 'Plans pour cette source',
		titleLabel: 'Titre du plan',
		total: (n: number) => `Total : ${n} min`,
		minutesLabel: 'Minutes',
		stepTitle: 'Étape',
		detailLabel: 'Ce qu’on fait',
		addStep: 'Ajouter une étape',
		removeStep: 'Retirer',
		openQuiz: (title: string) => `Quiz : ${title}`,
		save: 'Enregistrer les modifications',
		saving: 'Enregistrement...',
		saved: 'Enregistré',
		unsaved: 'Modifications non enregistrées',
		saveFailed: 'Impossible d’enregistrer le plan',
		del: 'Supprimer le plan',
		delConfirm: 'Supprimer définitivement',
		delCancel: 'Le garder',
		min: 'min',
		lengthNote: 'Changer la durée garde l’ordre et recalcule les minutes proportionnellement.',
		tryAgain: 'Réessayer',
		print: 'Imprimer',
		again: 'Refaire le plan',
		againTitle: 'Refaire ce plan',
		againBody:
			'Même source, même durée. Ce plan reste dans votre liste et le nouveau s’ouvre ensuite.',
		againHint:
			'Dites ce qu’il faut changer, par exemple : un échauffement plus court, plus d’oral ou une leçon de révision',
		againUnsaved: 'Les modifications non enregistrées ne sont pas reprises.',
	},
	it: {
		suggested: 'Consigliato per questa fonte',
		startGo: 'Crea il piano della lezione',
		hubTitle: 'Piano di lezione',
		hubShort: 'Piano di lezione',
		hubBlurb:
			'Trasforma una fonte in una lezione: riscaldamento, lettura o visione con pause, il tuo quiz, discussione, compiti. I minuti tornano sempre.',
		pickTitle: 'Pianifica una lezione da una fonte',
		pickLead: 'Parti da ciò con cui insegni. La durata la scegli dopo.',
		link: 'Piano di lezione',
		opening: 'Apertura',
		openFailed: 'Impossibile aprire',
		back: 'Torna alla fonte',
		backToSource: 'Torna alla fonte',
		createTitle: (title: string) => `Piano di lezione: ${title}`,
		createLead: 'Il piano usa questa fonte e gli esercizi che ne hai già ricavato.',
		outline: 'La lezione in breve',
		length: 'Durata della lezione',
		minutesOption: (n: number) => `${n} min`,
		notes: 'Qualcosa da includere nel piano? (facoltativo)',
		notesHint:
			'Per esempio: un lavoro di gruppo, un’attenzione al lessico nuovo o una lezione di ripasso',
		make: 'Prepara il piano',
		making: 'Preparazione del piano... ci vuole circa un minuto',
		failed: 'Il piano non è arrivato',
		noText: 'Questa fonte non ha ancora un testo. Aggiungi prima il testo.',
		existing: 'Piani per questa fonte',
		titleLabel: 'Titolo del piano',
		total: (n: number) => `Totale: ${n} min`,
		minutesLabel: 'Minuti',
		stepTitle: 'Fase',
		detailLabel: 'Cosa si fa',
		addStep: 'Aggiungi una fase',
		removeStep: 'Rimuovi',
		openQuiz: (title: string) => `Quiz: ${title}`,
		save: 'Salva le modifiche',
		saving: 'Salvataggio...',
		saved: 'Salvato',
		unsaved: 'Modifiche non salvate',
		saveFailed: 'Impossibile salvare il piano',
		del: 'Elimina il piano',
		delConfirm: 'Elimina definitivamente',
		delCancel: 'Tienilo',
		min: 'min',
		lengthNote: 'Cambiando la durata l’ordine resta e i minuti vengono ricalcolati in proporzione.',
		tryAgain: 'Riprova',
		print: 'Stampa',
		again: 'Crea di nuovo',
		againTitle: 'Crea di nuovo questo piano',
		againBody:
			'Stessa fonte e stessa durata. Questo piano resta nell’elenco e quello nuovo si apre subito dopo.',
		againHint:
			'Dì cosa cambiare, per esempio: un riscaldamento più breve, più produzione orale o una lezione di ripasso',
		againUnsaved: 'Le modifiche non salvate non vengono riportate.',
	},
	kk: {
		suggested: 'Осы материалға ұсынылады',
		startGo: 'Сабақ жоспарын жасау',
		hubTitle: 'Сабақ жоспары',
		hubShort: 'Сабақ жоспары',
		hubBlurb:
			'Материалды сабаққа айналдырыңыз: жылыту, кідірістері бар оқу немесе көру, сіздің тестіңіз, талқылау, үй тапсырмасы. Минуттар әрқашан сәйкес келеді.',
		pickTitle: 'Материалдан сабақ жоспарын жасау',
		pickLead: 'Сабақ беретін материалдан бастаңыз. Ұзақтығын келесі қадамда таңдайсыз.',
		link: 'Сабақ жоспары',
		opening: 'Ашылуда',
		openFailed: 'Ашу мүмкін болмады',
		back: 'Материалға оралу',
		backToSource: 'Материалға оралу',
		createTitle: (title: string) => `Сабақ жоспары: ${title}`,
		createLead: 'Жоспар осы материалды және одан жасаған жаттығуларыңызды пайдаланады.',
		outline: 'Сабақ қадамдары',
		length: 'Сабақ ұзақтығы',
		minutesOption: (n: number) => `${n} мин`,
		notes: 'Жоспарға тағы не қосу керек? (міндетті емес)',
		notesHint: 'Мысалы: топтық тапсырма, жаңа сөздерге баса назар немесе қайталау сабағы',
		make: 'Жоспар жасау',
		making: 'Жоспар жасалуда... шамамен бір минут',
		failed: 'Жоспар келмеді',
		noText: 'Бұл материалда әлі мәтін жоқ. Алдымен мәтінді қосыңыз.',
		existing: 'Осы материалдың жоспарлары',
		titleLabel: 'Жоспар атауы',
		total: (n: number) => `Барлығы: ${n} мин`,
		minutesLabel: 'Минут',
		stepTitle: 'Кезең',
		detailLabel: 'Не істеу керек',
		addStep: 'Кезең қосу',
		removeStep: 'Жою',
		openQuiz: (title: string) => `Тест: ${title}`,
		save: 'Өзгерістерді сақтау',
		saving: 'Сақталуда...',
		saved: 'Сақталды',
		unsaved: 'Сақталмаған өзгерістер бар',
		saveFailed: 'Жоспарды сақтау мүмкін болмады',
		del: 'Жоспарды жою',
		delConfirm: 'Біржола жою',
		delCancel: 'Қалдыру',
		min: 'мин',
		lengthNote: 'Ұзақтықты өзгерткенде реті сақталып, минуттар пропорционал қайта есептеледі.',
		tryAgain: 'Қайта көру',
		print: 'Басып шығару',
		again: 'Қайта жасау',
		againTitle: 'Жоспарды қайта жасау',
		againBody: 'Сол материал, сол ұзақтық. Бұл жоспар тізімде қалады, жаңасы одан кейін ашылады.',
		againHint:
			'Нені өзгерту керегін жазыңыз, мысалы: қысқарақ бастама, көбірек сөйлеу немесе қайталау сабағы',
		againUnsaved: 'Сақталмаған түзетулер жаңасына өтпейді.',
	},
	es: {
		suggested: 'Sugerido para este material',
		startGo: 'Crear plan de clase',
		hubTitle: 'Plan de clase',
		hubShort: 'Plan de clase',
		hubBlurb:
			'Convierte un material en una clase: calentamiento, lectura o visionado con pausas, tu cuestionario, debate, tarea. Los minutos siempre cuadran.',
		pickTitle: 'Planifica una clase a partir de un material',
		pickLead: 'Empieza por lo que enseñas. La duración la eliges después.',
		link: 'Plan de clase',
		opening: 'Abriendo',
		openFailed: 'No se pudo abrir',
		back: 'Volver al material',
		backToSource: 'Volver al material',
		createTitle: (title: string) => `Plan de clase: ${title}`,
		createLead: 'El plan usa este material y los ejercicios que ya hayas creado con él.',
		outline: 'La clase de un vistazo',
		length: 'Duración de la clase',
		minutesOption: (n: number) => `${n} min`,
		notes: '¿Algo que el plan deba incluir? (opcional)',
		notesHint:
			'Por ejemplo: una tarea en grupo, hincapié en vocabulario nuevo o una clase de repaso',
		make: 'Crear el plan',
		making: 'Creando el plan... tarda cerca de un minuto',
		failed: 'El plan no llegó',
		noText: 'Este material aún no tiene texto. Añade primero el texto.',
		existing: 'Planes de este material',
		titleLabel: 'Título del plan',
		total: (n: number) => `Total: ${n} min`,
		minutesLabel: 'Minutos',
		stepTitle: 'Paso',
		detailLabel: 'Qué hacer',
		addStep: 'Añadir un paso',
		removeStep: 'Quitar',
		openQuiz: (title: string) => `Cuestionario: ${title}`,
		save: 'Guardar cambios',
		saving: 'Guardando...',
		saved: 'Guardado',
		unsaved: 'Cambios sin guardar',
		saveFailed: 'No se pudo guardar el plan',
		del: 'Eliminar el plan',
		delConfirm: 'Eliminar para siempre',
		delCancel: 'Conservarlo',
		min: 'min',
		lengthNote: 'Al cambiar la duración se mantiene el orden y se reajustan los minutos.',
		tryAgain: 'Intentar de nuevo',
		print: 'Imprimir',
		again: 'Redactar otra vez',
		againTitle: 'Redactar este plan otra vez',
		againBody:
			'El mismo material y la misma duración. Este plan se queda en tu lista y el nuevo se abre después.',
		againHint:
			'Di qué cambiar, por ejemplo: un calentamiento más corto, más práctica oral o una clase de repaso',
		againUnsaved: 'Los cambios sin guardar no se trasladan.',
	},
	pt: {
		suggested: 'Sugerido para este material',
		startGo: 'Criar plano de aula',
		hubTitle: 'Plano de aula',
		hubShort: 'Plano de aula',
		hubBlurb:
			'Transforme um material em uma aula: aquecimento, leitura ou vídeo com pausas, seu quiz, discussão, tarefa de casa. Os minutos sempre fecham.',
		pickTitle: 'Planeje uma aula a partir de um material',
		pickLead: 'Comece pelo que você ensina. A duração você escolhe depois.',
		link: 'Plano de aula',
		opening: 'Abrindo',
		openFailed: 'Não foi possível abrir',
		back: 'Voltar ao material',
		backToSource: 'Voltar ao material',
		createTitle: (title: string) => `Plano de aula: ${title}`,
		createLead: 'O plano usa este material e os exercícios que você já criou com ele.',
		outline: 'Visão geral da aula',
		length: 'Duração da aula',
		minutesOption: (n: number) => `${n} min`,
		notes: 'Algo que o plano deva incluir? (opcional)',
		notesHint: 'Por exemplo: uma atividade em grupo, foco em palavras novas ou uma aula de revisão',
		make: 'Criar o plano',
		making: 'Criando o plano... leva cerca de um minuto',
		failed: 'O plano não veio',
		noText: 'Este material ainda não tem texto. Adicione o texto primeiro.',
		existing: 'Planos deste material',
		titleLabel: 'Título do plano',
		total: (n: number) => `Total: ${n} min`,
		minutesLabel: 'Minutos',
		stepTitle: 'Etapa',
		detailLabel: 'O que fazer',
		addStep: 'Adicionar etapa',
		removeStep: 'Remover',
		openQuiz: (title: string) => `Quiz: ${title}`,
		save: 'Salvar alterações',
		saving: 'Salvando...',
		saved: 'Salvo',
		unsaved: 'Alterações não salvas',
		saveFailed: 'Não foi possível salvar o plano',
		del: 'Excluir o plano',
		delConfirm: 'Excluir de vez',
		delCancel: 'Manter',
		min: 'min',
		lengthNote: 'Mudar a duração mantém a ordem e reajusta os minutos proporcionalmente.',
		tryAgain: 'Tentar de novo',
		print: 'Imprimir',
		again: 'Refazer o plano',
		againTitle: 'Refazer este plano',
		againBody:
			'O mesmo material e a mesma duração. Este plano continua na lista e o novo abre em seguida.',
		againHint:
			'Diga o que mudar, por exemplo: um aquecimento mais curto, mais prática oral ou uma aula de revisão',
		againUnsaved: 'As alterações não salvas não são levadas.',
	},
	de: {
		suggested: 'Empfohlen für dieses Material',
		startGo: 'Stundenplan erstellen',
		hubTitle: 'Stundenplan',
		hubShort: 'Stundenplan',
		hubBlurb:
			'Mach aus einem Material eine Unterrichtsstunde: Einstieg, Lesen oder Ansehen mit Pausen, dein Quiz, Gespräch, Hausaufgabe. Die Minuten gehen immer auf.',
		pickTitle: 'Eine Stunde aus einem Material planen',
		pickLead:
			'Fang mit dem Material an, mit dem du unterrichtest. Die Dauer wählst du als Nächstes.',
		link: 'Stundenplan',
		opening: 'Wird geöffnet',
		openFailed: 'Konnte nicht geöffnet werden',
		back: 'Zurück zum Material',
		backToSource: 'Zurück zum Material',
		createTitle: (title: string) => `Stundenplan: ${title}`,
		createLead: 'Der Plan nutzt dieses Material und die Übungen, die du schon daraus gemacht hast.',
		outline: 'Die Stunde im Überblick',
		length: 'Dauer der Stunde',
		minutesOption: (n: number) => `${n} Min.`,
		notes: 'Soll der Plan etwas Bestimmtes enthalten? (optional)',
		notesHint:
			'Zum Beispiel: eine Gruppenarbeit, Schwerpunkt auf neuen Wörtern oder eine Wiederholungsstunde',
		make: 'Plan erstellen',
		making: 'Der Plan wird erstellt... das dauert etwa eine Minute',
		failed: 'Der Plan kam nicht zurück',
		noText: 'Dieses Material hat noch keinen Text. Füge zuerst den Text hinzu.',
		existing: 'Pläne zu diesem Material',
		titleLabel: 'Titel des Plans',
		total: (n: number) => `Gesamt: ${n} Min.`,
		minutesLabel: 'Minuten',
		stepTitle: 'Schritt',
		detailLabel: 'Was zu tun ist',
		addStep: 'Schritt hinzufügen',
		removeStep: 'Entfernen',
		openQuiz: (title: string) => `Quiz: ${title}`,
		save: 'Änderungen speichern',
		saving: 'Wird gespeichert...',
		saved: 'Gespeichert',
		unsaved: 'Nicht gespeicherte Änderungen',
		saveFailed: 'Der Plan konnte nicht gespeichert werden',
		del: 'Plan löschen',
		delConfirm: 'Endgültig löschen',
		delCancel: 'Behalten',
		min: 'Min.',
		lengthNote:
			'Bei geänderter Dauer bleibt die Reihenfolge, die Minuten werden anteilig angepasst.',
		tryAgain: 'Erneut versuchen',
		print: 'Drucken',
		again: 'Noch einmal entwerfen',
		againTitle: 'Diesen Plan noch einmal entwerfen',
		againBody:
			'Gleiches Material, gleiche Dauer. Dieser Plan bleibt in deiner Liste, der neue öffnet sich danach.',
		againHint:
			'Sag, was sich ändern soll, zum Beispiel: ein kürzeres Warm-up, mehr Sprechen oder eine Wiederholungsstunde',
		againUnsaved: 'Nicht gespeicherte Änderungen werden nicht übernommen.',
	},
})
